/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  GetMBWBDetailsParams,
  MBWBDetailsResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get MB/WB history for a branch
 */
export const getMBWBDetails = (params?: GetMBWBDetailsParams, signal?: AbortSignal) => {
  return customInstance<MBWBDetailsResponseResponse>({
    url: `/bm-declaration-service/v1/GetMBWBDetails`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetMBWBDetailsQueryKey = (params?: GetMBWBDetailsParams) => {
  return [`/bm-declaration-service/v1/GetMBWBDetails`, ...(params ? [params] : [])] as const;
};

export const getGetMBWBDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMBWBDetails>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetMBWBDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMBWBDetails>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMBWBDetailsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMBWBDetails>>> = ({ signal }) =>
    getMBWBDetails(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMBWBDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMBWBDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getMBWBDetails>>>;
export type GetMBWBDetailsQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Get MB/WB history for a branch
 */
export const useGetMBWBDetails = <
  TData = Awaited<ReturnType<typeof getMBWBDetails>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetMBWBDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMBWBDetails>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMBWBDetailsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
